import { channelList } from '@com/utils/channel'
import generateShortId from '@/utils/generateId.js'
import * as metadata from '@/common/material-metadata'
import _ from 'lodash'

export const clickConfList = metadata.clickConfList

// 非交互素材 + mintegral 渠道
// MTG/DSP
export const mintegralChannelList = channelList.filter((item) =>
  [1, 2].some((id) => id === item.value),
)

// 非交互素材 + 大媒体渠道
// Google Adwords、Applovin、unity、Facebook，广点通、今日头条、ironsource、百度信息流、vungle、快手、其他
export const bigMediaChannelList = channelList
  .filter((item) =>
    [3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 99].some(
      (id) => id === item.value,
    ),
  )
  .map((item) => {
    return {
      ...item,
      label: item.alias || item.label, // 只有非交互素材中显示别名
    }
  })

export const nonInteractiveChannelList =
  mintegralChannelList.concat(bigMediaChannelList)

// 因为非交互素材在 pt 的交付列表中，会自动合并 MTG 和 DSP 渠道为 Mintegral 渠道；
// 仅仅从 nonInteractiveChannelList 中是获取不到 Mintegral 渠道的 label 的
// 因此在 exchange label 的时候，需要从所有的 channelList 中获取，
export const allNonInteractiveChannelList = channelList.map((item) => {
  return {
    ...item,
    label: item.alias || item.label, // 只有非交互素材中显示别名
  }
})

export const creationTypeList = [
  {
    value: 1,
    label: 'playable',
  },
  {
    value: 2,
    label: '动态endcard',
  },
  {
    value: 3,
    label: '视频设计',
  },
  {
    value: 4,
    label: '视频修改',
  },
  {
    value: 5,
    label: '图片设计',
  },
  {
    value: 6,
    label: '图片修改',
  },
  {
    value: 7,
    label: 'GIF',
  },
]

// playable/动态endcard
export const interactiveCreationTypeList = creationTypeList.filter((item) =>
  [1, 2].some((id) => id === item.value),
)

// 视频设计、视频修改、图片设计、图片修改、GIF
export const nonInteractiveCreationTypeList = creationTypeList.filter((item) =>
  [3, 4, 5, 6, 7, 8].some((id) => id === item.value),
)

export const generateCreation = () => {
  return {
    channel: '',
    type: '',
    languages: [],
    sizes: [],
    more_size: '', // 用户可针对该需求的创意要求新增尺寸，只会保存在当前创意要求下，不会存储到尺寸列表接口中
    _id: generateShortId(),
  }
}

/**
 * 使用渠道值交换非交互渠道 label
 * @param channelId {string|number|number[]}
 * @returns {string|*}
 */
export const useChannelIdExchangeNonInteractiveChannelLabel = (channelId) => {
  if (_.isArray(channelId)) {
    return channelId
      .map((id) => {
        return (
          allNonInteractiveChannelList.find(
            (channel) => channel.value === Number(id),
          ) || {}
        ).label
      })
      .join()
  }
  return (
    allNonInteractiveChannelList.find(
      (channel) => channel.value === Number(channelId),
    ) || {}
  ).label
}
